export class SaasWorkloadStatus {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workload",
            "baseName": "workload",
            "type": "SaasWorkload",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SaasBackupStatus",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasWorkloadStatus.attributeTypeMap;
    }
    constructor() {
    }
}
